/**
 * Auto-generated from SVG file. Do not edit manually.
 * Original: images/icons/success.svg
 */
import React from 'react';

export const SuccessIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
    {...props}
  >
    <circle cx="25" cy="25" r="25" fill="#25ae88"/><path fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M38 15 22 33l-10-8"/>
  </svg>
);
